import React from 'react'

import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const AddCountryCodeDate = ({ data, setData }) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-flex-col tw-gap-3">
      <label
        htmlFor="countryCode-dateTime"
        className="tw-text-sm tw-font-semibold tw-text-content-base"
      >
        {t('countryCode.date-time')}
      </label>
      <input
        id="countryCode-dateTime"
        name="countryCode-dateTime"
        type="datetime-local"
        required
        step="60"
        value={data.startDateTime?.replace(' ', 'T') ?? ''}
        onChange={(e) =>
          setData({ ...data, startDateTime: e.target.value.replace('T', ' ') })
        }
        className="tw-w-full tw-rounded-md tw-border tw-border-base-300 tw-bg-white tw-p-2 tw-text-content-base"
      />
    </div>
  )
}

export default AddCountryCodeDate
